/**
 * @param {Object} message
 * @returns {string|null}
 */
export const getWhatsAppMediaId = (message) => {
  if (message?.rawPayload?.document?.id) {
    return message.rawPayload.document.id;
  }

  if (message?.rawPayload?.image?.id) {
    return message.rawPayload.image.id;
  }

  if (message?.rawPayload?.video?.id) {
    return message.rawPayload.video.id;
  }

  if (message?.rawPayload?.audio?.id) {
    return message.rawPayload.audio.id;
  }

  if (message?.attachments?.[0]?.payload?.url) {
    return message.attachments[0].payload.url;
  }

  return null;
};

/**
 * @param {string} url
 * @returns {boolean}
 */
export const isWhatsAppMediaId = (url) => {
  if (!url) return false;

  return /^\d+$/.test(url) && !url.startsWith('http');
};

/**
 * @param {Object} attachment
 * @param {Object} message
 * @returns {string}
 */
export const getWhatsAppFilename = (attachment, message) => {
  if (attachment?.payload?.filename) {
    return attachment.payload.filename;
  }

  if (attachment?.payload?.name) {
    return attachment.payload.name;
  }

  if (message?.rawPayload?.document?.filename) {
    return message.rawPayload.document.filename;
  }

  if (message?.messageText) {
    return message.messageText;
  }

  return 'download';
};
